import type { CSSProperties } from "react";
import { readableTextColor, sanitizeTenantColor } from "../../lib/colorUtils";
import styles from "./TenantMark.module.css";

interface TenantMarkProps {
  name: string;
  color: string;
  logoUrl?: string;
  size?: "sm" | "lg";
}

/** A retailer's identity lockup: their own logo, or a color-coded initial
 * when none is set, beside their name. Used on the public signup page and
 * mirrored in the owner's brand-kit preview so both stay visually in sync. */
export function TenantMark({ name, color, logoUrl, size = "lg" }: TenantMarkProps) {
  const safeColor = sanitizeTenantColor(color);
  const style = {
    "--mark-color": safeColor,
    "--mark-ink": readableTextColor(safeColor, "#201c17", "#ffffff"),
  } as CSSProperties;

  return (
    <div className={`${styles.mark} ${size === "sm" ? styles.sm : styles.lg}`}>
      {logoUrl ? (
        <img className={styles.logo} src={logoUrl} alt="" style={style} />
      ) : (
        <span className={styles.initial} style={style} aria-hidden="true">
          {name.trim().charAt(0).toUpperCase() || "?"}
        </span>
      )}
      <span className={styles.name}>{name}</span>
    </div>
  );
}
